import { useEffect } from 'react'
import { useUser } from '@clerk/clerk-react'
import { TextToVideoForm } from '@/components/features/video'
import { AnalyticsService } from '@/services/analytics'

export function TextToVideoPage() {
  const { user } = useUser()

  useEffect(() => {
    AnalyticsService.trackViewItem('video_tools', 'text_to_video', 'Text to Video', user?.id)
    AnalyticsService.trackViewContent('Text to Video', user?.id)
  }, [user?.id])

  return (
    <div className="p-6 md:p-8 max-w-4xl mx-auto">
      <TextToVideoForm />
    </div>
  )
}
